import api from "./api";

export const callGetPhones = async () => {
    try {
        return await api.get(`/phones/web/active`);
    } catch (error) {
        console.log("Error callGetPhones");
        return error?.response || { status: 500 };
    }
};

export const callGetDashboardPhones = async (page, offset) => {
    try {
        return await api.get(`/phones/dashboard/pageable?page=${page}&offset=${offset}`);
    } catch (error) {
        console.log("Error callGetDashboardPhones");
        return error?.response || { status: 500 };
    }
};

export const callCreateDashboardPhone = async (data) => {
    try {
        return await api.post("/phones/dashboard/create", data);
    } catch (error) {
        console.log("Error callCreateDashboardPhone");
        return error?.response;
    }
};

export const callUpdateDashboardPhone = async (data) => {
    try {
        return await api.put(`/phones/dashboard/update/${data.phoneId}`, data);
    } catch (error) {
        console.log("Error callUpdateDashboardPhone");
        return error?.response || { status: 500 };
    }
};
